<template>
      <l-checkbox v-model="model">
        <slot></slot>
      </l-checkbox>
</template>

<script>
// import PayoutsVue from '../../pages/admin/Payouts.vue'
export default {
  name: 'Row-Selection-Checkbox',
  props: {
    filter: { type: Object, default: null }
  },
  data () {
    return {
      model: false,
      requestingSelectMode: false,
      otherRequest: false // = true if another component requested row selection mode
    }
  },
  created () {
    this.unsubscribe = this.$store.subscribe((mutation, state) => {
        // we leave select mode if there's a change in the table data,
      if (mutation.type === 'SET_PERIOD_SELECTED' || mutation.type === 'SET_COMPANY_SELECTED') {
        // Timeout is because otherwise it happens during table rendering and messes up the columns 
        setTimeout(()=>this.model = false, 0)
        return
      }
      // If it's this element that's requesting row selection mode, we reset the flag
      if (mutation.type === 'SELECT_OBJECTS' && this.requestingSelectMode) {
        //console.log('this request')
        this.requestingSelectMode = false
        this.otherRequest = false
        return
      }
      //   if another element is requesting the row selection mode, we check off the checkbox
      if (mutation.type === 'SELECT_OBJECTS' && !this.requestingSelectMode && this.model && this.$store.getters.selectedObjectsJson) {
        //console.log('other request')
        this.otherRequest = true
        this.model = false
        return
      }
    })
    
    this.unsubscribeAction = this.$store.subscribeAction((action, state) => {
      if (action.type === 'requestPayoutsSubmission' || action.type === 'submitPayoutsForPayment') {
        //this.model = false
      }
      if (action.type === 'closeModal' && this.model) {
        this.model = false
        this.$store.commit('STOP_SELECT_OBJECTS')
      }
    })
  },
  watch: {
    model: function (val) {
      //console.log('val: ', val)
      // If another element has requested the row selection mode, we just uncheck the checkbox

      // We toggle the selection mode on or off
      if (val) {
        this.requestingSelectMode = true
        this.$store.commit('SELECT_OBJECTS', this.filter)
      }
      else {
        if(this.$store.getters.selectedObjectsJson && !this.otherRequest) {
          this.$store.commit('STOP_SELECT_OBJECTS')
        }
      }
    }
  },
  beforeDestroy () {
    // we force a STOP_SELECT_OBJECTS in case user leaves the page after activating selectMode
    this.$store.commit('STOP_SELECT_OBJECTS')
    console.log('beforeDestroy')
    this.unsubscribe()
  }
}
</script>

<style>
</style>